import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

function cn(...inputs: (string | undefined | null | false)[]): string {
    return inputs.filter(Boolean).join(" ");
}

const glassButtonVariants = cva(
    "glass-button-inner",
    {
        variants: {
            size: {
                default: "",
                sm: "",
                lg: "",
                icon: "",
            },
        },
        defaultVariants: {
            size: "default",
        },
    }
);

const glassButtonTextVariants = cva(
    "glass-button-text",
    {
        variants: {
            size: {
                default: "size-default",
                sm: "size-sm",
                lg: "size-lg",
                icon: "size-icon",
            },
        },
        defaultVariants: {
            size: "default",
        },
    }
);

export interface GlassButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof glassButtonVariants> {
    contentClassName?: string;
    loading?: boolean;
}

const GlassButton = React.forwardRef<HTMLButtonElement, GlassButtonProps>(
    ({ className, children, size, contentClassName, loading, ...props }, ref) => {
        return (
            <div
                className={cn(
                    "glass-button-wrap",
                    className
                )}
            >
                <button
                    className={cn("glass-button", glassButtonVariants({ size }))}
                    ref={ref}
                    disabled={loading || props.disabled}
                    {...props}
                >
                    <span
                        className={cn(
                            glassButtonTextVariants({ size }),
                            contentClassName
                        )}
                    >
                        {loading ? (
                            <div className="spinner-sm"></div>
                        ) : (
                            children
                        )}
                    </span>
                </button>
                <div className="glass-button-shadow"></div>
            </div>
        );
    }
);
GlassButton.displayName = "GlassButton";

export { GlassButton, glassButtonVariants };
